import axios from 'axios';
import authService from './authService';
import { API_URL } from '@/config/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = authService.token.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
    }
    return Promise.reject(error);
  }
);

const bibleStudyService = {
  async buscarEstudoAtual() {
    const response = await api.get('/bible/study/current');
    return response.data;
  },

  async listarLivros() {
    const response = await api.get('/bible/books');
    return response.data;
  },

  async listarCapitulos(bookId) {
    const response = await api.get(`/bible/books/${bookId}/chapters`);
    return response.data;
  },

  async iniciarEstudo(payload = {}) {
    const response = await api.post('/bible/study/start', payload);
    return response.data;
  },

  async concluirLeitura(sessionId) {
    const response = await api.patch(`/bible/sessions/${sessionId}/complete`);
    return response.data;
  },

  async buscarNotas(sessionId) {
    const response = await api.get(`/bible/sessions/${sessionId}/notes`);
    return response.data;
  },

  async buscarMinhaNota(sessionId) {
    const response = await api.get(`/bible/sessions/${sessionId}/notes/me`);
    return response.data;
  },

  async salvarMinhaNota(sessionId, content) {
    const response = await api.put(`/bible/sessions/${sessionId}/notes/me`, { content });
    return response.data;
  },

  async perguntarIa({ sessionId, question, verse }) {
    const payload = {
      sessionId,
      question,
    };

    if (verse !== null && verse !== undefined && verse !== '') {
      payload.verse = Number(verse);
    }

    const response = await api.post('/bible/ai/ask', payload);
    return response.data;
  },
};

export default bibleStudyService;
